import { List } from '@mui/material';
import { NavListRoot } from 'components/nav-section/NavList';
import type { NavListProps } from 'components/nav-section/type';
import useCollapseDrawer from 'hooks/useCollapseDrawer';

type Props = { navItems: NavListProps[] };

export const NavSection = ({ navItems }: Props) => {
  const { isCollapse } = useCollapseDrawer();

  return (
    <List disablePadding sx={{ px: isCollapse ? 0.5 : 2 }}>
      {navItems.map((navItem, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: no available id or key here
        <NavListRoot key={index} list={navItem} />
      ))}
    </List>
  );
};
